import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntDefaultCheckboxComponent } from './int-default-checkbox.component';
import {IntAttrBindingModule} from "../../directives";



@NgModule({
  declarations: [
    IntDefaultCheckboxComponent
  ],
  imports: [
    CommonModule,
    IntAttrBindingModule
  ],
  exports: [
    IntDefaultCheckboxComponent
  ]
})
export class IntDefaultCheckboxModule { }
